import type { ReactNode } from "react";

export default function SectionHead({
  eyebrow,
  title,
  desc,
  right,
  accent,
}: {
  eyebrow: string;
  title: string;
  desc?: string;
  right?: ReactNode;
  accent?: boolean;
}) {
  return (
    <div className="flex flex-col gap-4 lg:flex-row lg:items-end lg:justify-between">
      <div className="max-w-2xl">
        <span
          className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-[11px] font-semibold ${
            accent ? "bg-accent-500/15 text-accent-300" : "bg-secondary-500/15 text-secondary-300"
          }`}
        >
          <i className={`${accent ? "ri-vip-crown-line" : "ri-focus-3-line"} text-sm`} />
          {eyebrow}
        </span>
        <h2 className="mt-3 font-heading text-xl font-black text-foreground-950 md:text-3xl">{title}</h2>
        {desc && <p className="mt-2 text-sm leading-relaxed text-foreground-600">{desc}</p>}
      </div>
      {right}
    </div>
  );
}